import { Box } from "@mui/material";

type UserCellProps = {
  firstName?: string;
  lastName?: string;
  email?: string;
};
export default function UserCell({
  firstName,
  lastName,
  email,
}: Readonly<UserCellProps>) {
  return (
    <Box>
      {lastName}, {firstName}
      <br />
      {email}
    </Box>
  );
}
